module.exports = __webpack_public_path__ + "static/img/accountusericon.37394037.png";